import PropTypes from 'prop-types';

import Gap from 'bloko/blocks/gap';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import TitleBlock from 'components/Admin/InvoiceDetail/Invoice/TitleBlock';
import AccountLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Account/AccountLink';
import EmployerLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Account/EmployerLink';
import ManagerLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Account/ManagerLink';
import PayerLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Payer/PayerLink';
import TableBody from 'components/Table/TableBody';
import TableCell, { TableCellKind } from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

const Account = ({ id, employerId, clickmeManagerEmail, payerId }) => {
    const trl = useTrls();

    return (
        <Gap bottom>
            <TitleBlock>
                {trl('admin.Invoices.InvoicesDetail.Invoice.Account.employer')}
                <EmployerLink employerId={employerId} />
            </TitleBlock>
            <Table fullWidth withStripes bordered>
                <TableBody>
                    <TableRow>
                        <TableCell kind={TableCellKind.Title}>
                            {trl('admin.Invoices.InvoicesDetail.Invoice.Account.number')}
                        </TableCell>
                        <TableCell>
                            <AccountLink accountId={id} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell kind={TableCellKind.Title}>
                            {trl('admin.Invoices.InvoicesDetail.Invoice.Account.manager')}
                        </TableCell>
                        <TableCell>
                            <ManagerLink managerEmail={clickmeManagerEmail} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell kind={TableCellKind.Title}>
                            {trl('admin.Invoices.InvoicesDetail.Invoice.Payer.title')}
                        </TableCell>
                        <TableCell>
                            <PayerLink payerId={payerId} />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Gap>
    );
};

Account.propTypes = {
    id: PropTypes.number,
    employerId: PropTypes.number,
    clickmeManagerEmail: PropTypes.string,
    payerId: PropTypes.number,
};

export default Account;
